import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=65e07fa4&scoped=true&"
import script from "./modal.vue?vue&type=script&setup=true&lang=js&"
export * from "./modal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./modal.vue?vue&type=style&index=0&id=65e07fa4&prod&scoped=true&lang=css&"
import style1 from "./modal.vue?vue&type=style&index=1&id=65e07fa4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e07fa4",
  null
  
)

export default component.exports